import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  required,
  minLength,
  email,
  BooleanInput,
  FormDataConsumer,
} from 'react-admin'
import { EmailVerificationInfoAlert } from '../../components/EmailVerificationAlerts';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { EmployeeType } from '../../models';
import { formatAttendantLabel } from '../../utils';

const profilesSx = {
  width: 220,
};

const validateEmail = [required(), email()]
const validatePassword = [required(), minLength(6)];

export default props => {
  return (
    <Permission permission={PERMISSIONS.MANAGE_ATTENDANT_USER}>
      <Create {...props} title="Cadastrar usuário frentista">
        <SimpleForm sanitizeEmptyValues defaultValues={{ chainId: getChainId(), type: EmployeeType.attendant }} sx={{ maxWidth: 600 }}>
          <Permission permission={PERMISSIONS.ADMIN}>
            <ReferenceInput {...props} label="Rede" source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null} >
              <SelectInput optionText="name" />
            </ReferenceInput>
          </Permission>
          <TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                source="attendantId"
                reference="attendants"
                filter={{ chainId: formData.chainId }}
                //@ts-ignore
                perPage={null}
                style={{ width: 256 }}
              >
                <SelectInput source="name" label="Frentista" optionText={record => formatAttendantLabel(record)} validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                sx={profilesSx}
                label="Perfil"
                source="profileId"
                reference="profiles"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={{ chainId: formData.chainId }}>
                <RadioButtonGroupInput optionText="name" validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
          <EmailVerificationInfoAlert />
        </SimpleForm>
      </Create>
    </Permission>
  )
}